export default function MenuSelecaoContextoService(
  $state,
  $cacheFactory,
  acessoService,
  userAccessContext,
  sistemaContextoHolderService
) {
  const getEntidadeAtual = () => {
    return userAccessContext.getUserAccess();
  };

  const getEntidades = () => {
    return acessoService.getAcessosAgrupadosPorEntidade()
      .then(entidades => _.sortBy(entidades, 'nome'));
  }

  const getSistemas = () => {
    return acessoService.getSistemasByEntidade(userAccessContext.getUserAccess().values.entity)
      .then(sistemas => _.sortBy(sistemas, 'name'));
  }

  const getSubcontextos = () => {
    return acessoService.meusAcessosPorSubcontexto();
  }

  const getSistemaAtual = () => {
    return sistemaContextoHolderService.getObject();
  }

  const clearSistema = () => {
    return sistemaContextoHolderService.remove();
  }

  const selecionarEntidade = (entidade) => {
    cacheClear();
    $state.go('main.entidade.selected.sistema', { entidade: entidade.context });
  }

  const selecionarSistema = (sistema) => {
    cacheClear();
    const params = { APP_SYSTEM: sistema.id };

    if (!sistema.urlSubcontext) {
      return $state.go('main.entidade.selected.sistema.selected.visaoGeralSistema', params);
    }

    const entidade = userAccessContext.getUserAccess().values.entity;
    return acessoService.getAcessoPrincipal(sistema.id, entidade)
      .then(acessoPrincipal => $state.go(
        acessoPrincipal
          ? 'main.entidade.selected.sistema.selected.visaoGeralSistema'
          : 'main.entidade.selected.sistema.selected.subcontexto',
        params
      ));
  }

  const selecionarSubcontexto = (subcontexto, subcontextoConfig) => {
    const values = {
      [subcontextoConfig.id]: subcontexto.id
    };

    const params = {
      SUBCONTEXTO_HASH: btoa(JSON.stringify(values))
    };

    return $state.go('main.entidade.selected.sistema.selected.subcontexto.selected.visaoGeralSubcontexto', params);
  }

  const cacheClear = () => {
    console.debug(`$http cache has been cleared`);
    $cacheFactory.get('$http').removeAll();
  }

  return {
    getEntidadeAtual,
    getEntidades,
    getSistemas,
    getSubcontextos,
    getSistemaAtual,
    selecionarEntidade,
    selecionarSistema,
    selecionarSubcontexto,
    clearSistema,
    cacheClear
  }
}

MenuSelecaoContextoService.$inject = [
  '$state',
  '$cacheFactory',
  'AcessoService',
  'UserAccessContext',
  'SistemaContextoHolderService',
];
